import React, { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import statusDiscount from "../campaign-banner/status-discount";
import typeAmountDiscount from "../campaign-banner/type-amount";

export default function SelectPositionBanner() {
  const [discounts, setDiscounts] = useState([]);
  const [tagHtmlPositionBanner, setTagHtmlPositionBanner] = useState();

  const sendForm = async (e) => {
    e.preventDefault();
    const positionTagHtmlID = document.querySelector("#html-tag-id").value;
    const posotitonTagHtmlIDData = await getPosotitonTagHtmlIDData(
      positionTagHtmlID
    );
    if (!posotitonTagHtmlIDData) {
      setTagHtmlPositionBanner();
      return;
    }

    await getAllDiscounts(positionTagHtmlID);
  };

  const getPosotitonTagHtmlIDData = async (positionTagHtmlID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestGetPosotitonTagHtmlIDData(
      positionTagHtmlID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return false;
    }
    return result;
  };

  const sendRequestGetPosotitonTagHtmlIDData = async (positionTagHtmlID) => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/report/" +
          positionTagHtmlID,
        headersRequest
      );
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getAllDiscounts = async (positionTagHtmlID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllDiscounts = await sendRequestGetAllDiscounts(
      positionTagHtmlID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllDiscounts) {
      return;
    }
    setDiscounts(resultSendRequestGetAllDiscounts.reverse());
    setTagHtmlPositionBanner(positionTagHtmlID);
  };

  const sendRequestGetAllDiscounts = async (positionTagHtmlID) => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner/" +
          positionTagHtmlID +
          "/position-tag-html-id",
        headersRequest
      );
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deleteDiscount = async (discountID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestDeleteDiscount = await sendRequestDeleteDiscount(
      discountID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestDeleteDiscount) {
      return;
    }
    await getAllDiscounts(document.querySelector("#html-tag-id").value);
  };

  const sendRequestDeleteDiscount = async (discountID) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner/" +
          discountID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateStatusTagDiscount = (status) => {
    return (
      <>
        <span
          className={`badge  ${
            status === statusDiscount.typeGroupPublisher.DISABLE
              ? "badge-danger"
              : ""
          }  ${
            status === statusDiscount.typeGroupPublisher.ENABLE
              ? "badge-success"
              : ""
          } 
            `}
        >
          {statusDiscount.getTypeGroupPublisherPersianName()[status]}
        </span>
      </>
    );
  };

  const changeActiveDiscount = async (discountID, active) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllDiscounts =
      await sendRequestChangeActiveDiscount(discountID, active);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllDiscounts) {
      return;
    }
    await getAllDiscounts(tagHtmlPositionBanner);
  };

  const sendRequestChangeActiveDiscount = async (discountID, active) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner/" +
          discountID +
          "/active/" +
          active,
        {},
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateDiscountTableTagHtml = (discounts) => {
    if (discounts.length == 0) {
      return <></>;
    }

    return (
      <>
        <div className="table-responsive">
          <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
            <thead>
              <th>#</th>
              <th>شماره</th>
              <th>مقدار</th>
              <th>تاریخ شروع</th>
              <th>تاریخ پایان</th>
              <th>فعال</th>
              <th>تاریخ درج</th>
              <th>تاریخ ویرایش</th>
              <th>عملیات</th>
            </thead>
            <tbody>
              {discounts.map((discount, index) => {
                let discountActive = +discount.active;
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{discount._id}</td>
                    <td>{discount.amount}%</td>
                    <td dir="ltr">
                      {helpersNumbers.toPersianNum(
                        discount.start_date.replace("_", " ")
                      )}
                    </td>
                    <td dir="ltr">
                      {helpersNumbers.toPersianNum(
                        discount.end_date.replace("_", " ")
                      )}
                    </td>
                    <td>{generateStatusTagDiscount(discountActive)}</td>
                    <td dir="ltr">
                      {helpersNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          discount.created_at
                        ) +
                          " " +
                          moment(discount.created_at).local().format("HH:mm:ss")
                      )}
                    </td>
                    <td dir="ltr">
                      {helpersNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          discount.updated_at
                        ) +
                          " " +
                          moment(discount.updated_at).local().format("HH:mm:ss")
                      )}
                    </td>
                    <td>
                      <span>
                        <span className="pl-2 ">
                          <span
                            className={`btn 
                      ${
                        discountActive ===
                        statusDiscount.typeGroupPublisher.ENABLE
                          ? "btn-danger"
                          : ""
                      }
                        ${
                          discountActive ===
                          statusDiscount.typeGroupPublisher.DISABLE
                            ? "btn-primary"
                            : ""
                        }`}
                            title={
                              discountActive === 1
                                ? "غیرفعال کردن"
                                : "فعال کردن"
                            }
                            onClick={(e) => {
                              changeActiveDiscount(
                                discount._id,
                                +!discount.active
                              );
                            }}
                          >
                            <i
                              className={` 
          ${
            discountActive === statusDiscount.typeGroupPublisher.ENABLE
              ? "fa fa-power-off"
              : ""
          }
            ${
              discountActive === statusDiscount.typeGroupPublisher.DISABLE
                ? "fas fa-play"
                : ""
            }

            `}
                            ></i>
                          </span>
                        </span>
                        <span className="pl-2">
                          <Link
                            to={
                              "/manage/discount/edit-position-banner/" +
                              discount._id +
                              "/position-tag-html-id/" +
                              tagHtmlPositionBanner
                            }
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>
                        <span>
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              deleteDiscount(discount._id);
                            }}
                            className="btn btn-danger"
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </span>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const generateButtonAddDiscount = () => {
    return (
      <div className="pt-2">
        <span className="px-2">
          <a
            href={`/manage/discount/add-position-banner/${tagHtmlPositionBanner}`}
            className="btn btn-primary"
            target="_blank"
          >
            <span>
              <i className="fa fa-plus"></i>
            </span>
            <span>اضافه کردن کد تخفیف</span>
          </a>
        </span>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-discount"
        activeItem="select-position-banner-discount"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  تخفیف به هر جایگاه بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning">
                این بخش فعلا آماده نشده است
              </div>
              <div className="alert alert-warning d-none">
                حد امکان از ویرایش و حذف تخفیف پرهیز کنید.می توانید کد تخفیف
                غیرفعال و یک کد تخفیف جدید بسازید.
              </div>
              <div className="d-none">
                <form onSubmit={sendForm}>
                  <div>
                    <label>id تگ html جایگاه مورد نظر خود را وارد کنید</label>
                  </div>
                  <div className="input-group pt-3 mb-3">
                    <input
                      type="text"
                      id="html-tag-id"
                      className="form-control"
                      placeholder="hilite-position-"
                      required
                    />
                    <div className="input-group-append">
                      <button className="btn btn-primary" type="submit">
                        نمایش تخفیف
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {generateDiscountTableTagHtml(discounts)}
              {tagHtmlPositionBanner && generateButtonAddDiscount()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
